module.exports = __webpack_public_path__ + "img/icons B_15.5f48068f.svg";